var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 55,
    viewBox: "0 0 59 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4909 51.8318V46.8954C39.4909 44.277 38.4508 41.7659 36.5993 39.9144C34.7478 38.0629 32.2366 37.0227 29.6182 37.0227H12.3409C9.72252 37.0227 7.21135 38.0629 5.35986 39.9144C3.50836 41.7659 2.4682 44.277 2.4682 46.8954V51.8318",
    stroke: "#7FB95F",
    strokeWidth: 4.93636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9795 27.15C26.4321 27.15 30.8523 22.7298 30.8523 17.2773C30.8523 11.8247 26.4321 7.40454 20.9795 7.40454C15.527 7.40454 11.1068 11.8247 11.1068 17.2773C11.1068 22.7298 15.527 27.15 20.9795 27.15Z",
    stroke: "#7FB95F",
    strokeWidth: 4.93636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3636 19.7455V34.5545",
    stroke: "#7FB95F",
    strokeWidth: 4.93636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7682 27.15H41.9591",
    stroke: "#7FB95F",
    strokeWidth: 4.93636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.f603a9af09755011d5f884c5d6e8e99d.svg";
export { ForwardRef as ReactComponent };